module.exports = __webpack_public_path__ + "static/media/nike-like-a-lioness.ff22a43d.jpg";